"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("@pixum/text"));
require("./style.css");
var StarRating = function StarRating(_a) {
  var className = _a.className,
    _b = _a.description,
    description = _b === void 0 ? '' : _b,
    href = _a.href,
    onClick = _a.onClick,
    _c = _a.linked,
    linked = _c === void 0 ? true : _c,
    _d = _a.showDescription,
    showDescription = _d === void 0 ? true : _d,
    value = _a.value,
    _e = _a.variant,
    variant = _e === void 0 ? 'footnote' : _e;
  var hasHref = !!href;
  var Tag = hasHref ? 'a' : 'div';
  var tagProperties = {};
  hasHref && (tagProperties.href = href);
  !!onClick && (tagProperties.onClick = onClick);
  var text = (value.toFixed(1) + " " + description).trim();
  var customProperties = {
    '--rating-value': value
  };
  return react_1.default.createElement(Tag, __assign({
    className: (0, clsx_1.default)('rating', className, linked && 'description-is-linked')
  }, tagProperties), react_1.default.createElement("div", {
    style: customProperties
  }), showDescription && react_1.default.createElement(text_1.default, {
    variant: variant
  }, text));
};
exports.default = StarRating;